import type { ChartSpec } from "@/types";

const VALUE_LABELS = ["x", "y", "name", "label"] as const;
export const TOOLTIP_LABELS = [
  "size",
  "Open",
  "High",
  "Low",
  "Close",
  "Value",
  "Minimum",
  "Lower quartile",
  "Median",
  "Upper quartile",
  "Maximum",
] as const;
export const SCROLL_HINT = "Scroll horizontally to explore the full flow.";

export function chartTextSources(spec: ChartSpec): string[] {
  return [
    spec.title,
    "Save as PNG",
    "Chart data:",
    SCROLL_HINT,
    ...TOOLTIP_LABELS,
    ...spec.data.labels,
    ...spec.data.datasets.flatMap((dataset) => [
      dataset.label,
      ...dataset.values.flatMap((value) =>
        value && typeof value === "object"
          ? VALUE_LABELS.flatMap((key) =>
              typeof value[key] === "string" ? [value[key] as string] : [],
            )
          : [],
      ),
    ]),
    ...(spec.data.links?.flatMap((link) => [link.source, link.target]) ?? []),
    ...(spec.data.secondaryAxis ? [spec.data.secondaryAxis.name] : []),
  ];
}

export function translateChartSpec(
  spec: ChartSpec,
  translate: (text: string) => string,
): ChartSpec {
  return {
    ...spec,
    title: translate(spec.title),
    data: {
      ...spec.data,
      // Category names, series names and flow endpoints are identities.
      // Keep them distinct when Google gives different sources the same label;
      // axis, legend, label and tooltip formatters translate presentation only.
      ...(spec.data.secondaryAxis && {
        secondaryAxis: {
          ...spec.data.secondaryAxis,
          name: translate(spec.data.secondaryAxis.name),
        },
      }),
    },
  };
}
